import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const mainSponsors = [
  { name: "Kinskofer Holz Lehm Haus", logo: "https://customer-assets.emergentagent.com/job_run-for-ella/artifacts/ioi6nfmn_logo_kinskofer_quer_cmyk_300dpi.avif", url: "https://kinskofer-holzhaus.de/" },
  { name: "Raiffeisenbank Oberpfälzer Jura", logo: "https://customer-assets.emergentagent.com/job_run-for-ella/artifacts/1gy37ljz_Logo_RGB_zweizeilig_links_pos_AKTUELL.avif", url: "https://www.rb-opf-jura.de/startseite.html" },
  { name: "Ernsberger Wohnbau", logo: "https://customer-assets.emergentagent.com/job_run-for-ella/artifacts/1wsatkfn_Ernsberger%20Wohnbau.avif", url: "https://www.ernsberger-wohnbau.de/" },
];

const partnerSponsors = [
  { name: "Betreuungsbüro Ziegaus", logo: "https://customer-assets.emergentagent.com/job_run-for-ella/artifacts/j42eaorf_0db440_1e13ad9a3d7d4d8387ed789e14457764~mv2.avif", url: null },
  { name: "Gasthaus Neugebauer", logo: "https://customer-assets.emergentagent.com/job_run-for-ella/artifacts/ilje43d3_0db440_61fae593f90a47acb4d35719a492c37e~mv2.avif", url: "https://gasthaus-neugebauer.de/" },
  { name: "Fritz Ehrensberger", logo: "https://customer-assets.emergentagent.com/job_run-for-ella/artifacts/hkh5sffd_0db440_aa919eda0b0348beac07ddbb52fcc967~mv2.avif", url: "https://www.ehrensberger-gmbh.de/" },
  { name: "Weidinger Versichert", logo: "https://customer-assets.emergentagent.com/job_run-for-ella/artifacts/j1cexrll_0db440_d125192ca64e4746a349eca7eb2455aa~mv2.avif", url: "https://www.weidinger-versichert.de/" },
  { name: "Autohaus Vasold", logo: "https://customer-assets.emergentagent.com/job_65cff9e4-1fb7-4087-8c22-d5f62489d89d/artifacts/06mgn326_autohausvasold_ohne_Schatten%20%283%29.svg", url: "https://www.autohaus-vasold.de/" },
  { name: "Orange Immobilien", logo: "https://customer-assets.emergentagent.com/job_run-for-ella/artifacts/6vxetdmw_Orange_Immobilien_Logo.avif", url: "https://orange-immobilien.de/immobilienmakler-regensburg/" },
  { name: "Fahrschulen Schuster", logo: "https://customer-assets.emergentagent.com/job_run-for-ella/artifacts/7ol87ty0_FahrschulenSchusterLogo.avif", url: "https://www.fahrschulen-schuster.de/parsberg/" },
  { name: "Formaxx AG", logo: "https://customer-assets.emergentagent.com/job_run-for-ella/artifacts/4ss4m8ju_Formaxx_ag_logo.avif", url: "https://formaxx.de/standort/parsberg/" },
  { name: "Naturalis", logo: "https://customer-assets.emergentagent.com/job_run-for-ella/artifacts/ihvann5b_491951391_987472600252870_7070819750982631720_n%20%281%29.avif", url: "https://www.naturalis-gmbh.de/" },
  { name: "Bit HD", logo: "https://customer-assets.emergentagent.com/job_run-for-ella/artifacts/3fsu2ksv_Bit_HD_Logo.avif", url: "https://www.bit-hd.de/index.php/unternehmen" },
  { name: "Freitag", logo: "/sponsors/freitag.png", url: "https://elektro-freitag.de/" },
  { name: "Neumarkter Lammsbräu", logo: "/sponsors/lammsbraeu.png", url: "https://www.lammsbraeu.de/" },
  { name: "ESS Erlanger Sicherheitsservice", logo: "/sponsors/ess.png", url: "https://www.nwsgmbh.de/organisation/ess-erlanger-sicherheits-service/" },
];

export default function Sponsors() {
  const [headerRef, headerVisible] = useScrollAnimation({ threshold: 0.2 });
  const [mainRef, mainVisible] = useScrollAnimation({ threshold: 0.15 });
  const [partnerRef, partnerVisible] = useScrollAnimation({ threshold: 0.1 });

  return (
    <section id="sponsoren" data-testid="sponsors-section" className="py-20 md:py-28" style={{ background: "#F8F9FA" }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div 
          ref={headerRef}
          className={`text-center mb-12 md:mb-16 animate-fade-up ${headerVisible ? 'visible' : ''}`}
        >
          <p className="font-accent text-xl md:text-2xl mb-2" style={{ color: "#7DD4B5" }}>
            Danke an unsere
          </p>
          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight" style={{ color: "#1F2937" }}>
            Sponsoren & Partner
          </h2>
          <div className="section-divider mx-auto mt-4" />
        </div>

        {/* Main Sponsors */}
        <div ref={mainRef} className="mb-12">
          <h3 className="font-heading text-lg font-semibold text-center mb-6" style={{ color: "#b46eb6" }}>
            Hauptsponsoren
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
            {mainSponsors.map((s, i) => (
              <a
                key={i}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`sponsor-main-${i}`}
                className={`flex items-end justify-center rounded-xl border border-gray-100 bg-white hover:shadow-lg hover:border-[#b46eb6]/30 transition-all p-6 md:p-8 cursor-pointer h-36 md:h-44 card-animate ${mainVisible ? 'visible' : ''}`}
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                <img 
                  src={s.logo} 
                  alt={s.name} 
                  className={`w-auto object-contain ${i === 0 ? 'max-h-28 md:max-h-32' : 'max-h-16 md:max-h-20'}`} 
                  loading="lazy" 
                />
              </a>
            ))}
          </div>
        </div>

        {/* Partner Sponsors */}
        <div ref={partnerRef}>
          <h3 className="font-heading text-lg font-semibold text-center mb-6" style={{ color: "#b46eb6" }}>
            Partnersponsoren
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
            {partnerSponsors.slice(0, 10).map((s, i) => 
              s.url ? (
                <a
                  key={i}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`sponsor-partner-${i}`}
                  className={`flex items-center justify-center rounded-xl border border-gray-100 bg-white hover:shadow-lg hover:border-[#b46eb6]/30 transition-all p-4 md:p-6 cursor-pointer card-animate ${partnerVisible ? 'visible' : ''}`}
                  style={{ transitionDelay: `${i * 50}ms` }}
                >
                  <img src={s.logo} alt={s.name} className="max-h-14 md:max-h-16 w-auto object-contain" loading="lazy" />
                </a>
              ) : (
                <div
                  key={i}
                  data-testid={`sponsor-partner-${i}`}
                  className={`flex items-center justify-center rounded-xl border border-gray-100 bg-white hover:shadow-md transition-all p-4 md:p-6 card-animate ${partnerVisible ? 'visible' : ''}`}
                  style={{ transitionDelay: `${i * 50}ms` }}
                >
                  <img src={s.logo} alt={s.name} className="max-h-14 md:max-h-16 w-auto object-contain" loading="lazy" />
                </div>
              )
            )}
          </div>
          <div className="flex flex-wrap justify-center gap-3 md:gap-4 mt-3 md:mt-4">
            {partnerSponsors.slice(10).map((s, i) => (
              <a
                key={i + 10}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`sponsor-partner-${i + 10}`}
                className={`flex items-center justify-center rounded-xl border border-gray-100 bg-white hover:shadow-lg hover:border-[#b46eb6]/30 transition-all p-4 md:p-6 cursor-pointer card-animate w-[calc(50%-6px)] sm:w-[calc(33.333%-8px)] md:w-[calc(20%-13px)] ${partnerVisible ? 'visible' : ''}`}
                style={{ transitionDelay: `${(i + 10) * 50}ms` }}
              >
                <img src={s.logo} alt={s.name} className={`w-auto object-contain ${s.name === "Neumarkter Lammsbräu" ? "max-h-20 md:max-h-24" : "max-h-14 md:max-h-16"}`} loading="lazy" />
              </a>
            ))}
          </div>
        </div>

        <div className="text-center mt-10">
          <p className="text-base" style={{ color: "#4B5563" }}>
            Möchtest du Sponsor werden?{" "}
            <a
              href="mailto:info@runforrett.de"
              data-testid="sponsor-contact-link"
              className="font-semibold underline underline-offset-4 hover:no-underline transition-all"
              style={{ color: "#b46eb6" }}
            >
              Kontaktiere uns
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
